import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { dynatraceUtil } from '@uhg-uhcpp-sde-core/monstera-utility';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'POST_TIN_MANAGEMENT_API';

export const resetPostTinManagement = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);
  const action = useAction(() => {
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
    };
  });
  return [result, action];
};

export const usePostTinApi = () => {
  const result = useSelector((state) => state[ACTION_TYPE]);

  const action = useAction((args) => {
    const { tins = [] } = args;
    const eapm = window.elasticApm;
    let dtrumActionId;
    if (eapm) {
      window.elasticApm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: true,
      });
    }
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_RESET` });
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      dtrumActionId = dynatraceUtil.startAction(ACTION_TYPE, `${config('APIM_STARGATE_URL')}${config('TIN_MANAGEMENT_API')}?q=${ACTION_TYPE}`);
      fetch(`${config('APIM_STARGATE_URL')}${config('TIN_MANAGEMENT_API')}`, {
        withCredentials: 'include',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tins }),
      })
        .then((res) => {
          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('TIN_MANAGEMENT_API'),
              userInfo: args?.userInfo,
              method: 'POST',

              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
              // result: hasReportCode ? 'success' : 'error',
            },
          });
          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('FEEDBACK_URL'),
            status: 0,
            message: 'Success',
            url: window.location.href,
            result: 'success',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
          return res.status;
        })
        .then((res) => {
          const statusJson = { status: res };
          if (res !== 200) {
            dispatch({
              type: `${ACTION_TYPE}_ERROR`,
              payload: statusJson,
            });
          } else {
            dispatch({
              type: `${ACTION_TYPE}_COMPLETED`,
              payload: statusJson,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });
          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('TIN_MANAGEMENT_API'),
              userInfo: args?.userInfo,
              method: 'POST',
              operationName: ACTION_TYPE,
              // code: res.status,
              // message: res.statusText,
            },
          });

          event('Dynatrace_event', {
            actionId: dtrumActionId,
            endpoint: config('TIN_MANAGEMENT_API'),
            status: 0,
            message: 'Error',
            url: window.location.href,
            result: 'error',
            operationName: ACTION_TYPE,
            uuid: args?.userInfo?.uuid,
          });
        });
    };
  });

  return [result, action];
};
